@switch (context ? context.type : '') {
    @default {
        <fui-edit-password-input [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                                 [allowAutocomplete]="allowAutocomplete"
                                 (focussed$)="onFocussed($event)" [notation]="notation"
                                 [placeholder]="placeholder"></fui-edit-password-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-password-input [disabled]="disabled" #input [(ngModel)]="value" [placeholder]="placeholder"
                                   (focussed$)="onFocussed($event)">
        </fui-filter-password-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-password-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                                   (focussed$)="onFocussed($event)" [notation]="notation" [placeholder]="placeholder">
        </fui-inline-password-input>
    }
    @case (contextType.PILL) {
        <fui-password-pill [control]="control" [disabled]="disabled" [label]="label" #input [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" [placeholder]="placeholder"></fui-password-pill>
    }
}
